import request from '@/utils/request'

export function getExamScheduleConfigPage(params) {
  return request({
    url: '/exam-schedule-configs/page',
    method: 'get',
    params
  })
}

export function listExamScheduleConfigs(params) {
  return request({
    url: '/exam-schedule-configs/list',
    method: 'get',
    params
  })
}

export function matchExamScheduleConfig(params) {
  return request({
    url: '/exam-schedule-configs/match',
    method: 'get',
    params
  })
}

export function createExamScheduleConfig(data) {
  return request({
    url: '/exam-schedule-configs',
    method: 'post',
    data
  })
}

export function updateExamScheduleConfig(id, data) {
  return request({
    url: `/exam-schedule-configs/${id}`,
    method: 'put',
    data
  })
}

export function deleteExamScheduleConfig(id) {
  return request({
    url: `/exam-schedule-configs/${id}`,
    method: 'delete'
  })
}
